import React, { useState } from "react";
import "../../assets/css/sidebar.css";
import { Col, Modal, Button } from "react-bootstrap";
import { Link, NavLink, useNavigate } from "react-router-dom";
import {
  RiNotificationBadgeFill,
  RiShieldUserFill,
  RiShoppingCartFill,
} from "react-icons/ri";
import { BsFillCalendarEventFill } from "react-icons/bs";
import { FaPowerOff } from "react-icons/fa";
import { MdDeliveryDining } from "react-icons/md";
import Profile from "../../assets/jj2.png";

export default function Sidebar() {
  const [showLogout, setShowLogout] = useState(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    setShowLogout(false);
    navigate("/");
  };
  
  const current = new Date();
  const currentDate = `${current.getDate()}/${
    current.getMonth() + 1
  }/${current.getFullYear()}`;

  return (
    <>
      <Col lg={2} className="sidebar p-3 bg-light shadow d-none d-lg-block">
        <Col className="d-flex justify-content-start align-items-center">
          <img
            src={Profile}
            alt="chakara profile"
            height="auto"
            width="40%"
            className="me-2"
          />
          <Col>
            <Link to="/landing" className="text-decoration-none text-dark">
              <span>CHAKARA ART AND CRAFT</span>
            </Link>
            <br />
            <span className="text-secondary">
              <small>{currentDate}</small>
            </span>
          </Col>
        </Col>
        <Col className="sidebarMenu mt-3">
          <ul>
            <li>
              <NavLink to="/notification" className={({ isActive }) => isActive ? "active-link" : ""}>
                <RiNotificationBadgeFill
                  className="text-dark me-2"
                  style={{ fontSize: "1em" }}
                />
                Notifications
              </NavLink>
            </li>
            <li>
              <NavLink to="/userDetails" className={({ isActive }) => isActive ? "active-link" : ""}>
                <RiShieldUserFill
                  className="text-dark me-2"
                  style={{ fontSize: "1em" }}
                />
                Managing Users
              </NavLink>
            </li>
            <li>
              <NavLink to="/productDetails" className={({ isActive }) => isActive ? "active-link" : ""}>
                <RiShoppingCartFill
                  className="text-dark me-2"
                  style={{ fontSize: "1em" }}
                />
                Product List
              </NavLink>
            </li>
            <li>
              <NavLink to="/productOfMonth" className={({ isActive }) => isActive ? "active-link" : ""}>
                <BsFillCalendarEventFill
                  className="text-dark me-2"
                  style={{ fontSize: "1em" }}
                />
                Product Of The Month
              </NavLink>
            </li>
            <li>
              <NavLink to="/courier" className={({ isActive }) => isActive ? "active-link" : ""}>
                <MdDeliveryDining
                  className="text-dark me-2"
                  style={{ fontSize: "1.2em" }}
                />
                Courier
              </NavLink>
            </li>
            <li>
              <div onClick={() => setShowLogout(true)} style={{ cursor: "pointer", display: "flex", alignItems: "center" }} className="text-dark">
                <FaPowerOff
                  className="text-danger me-2"
                  style={{ fontSize: "1.2em" }}
                />
                Logout
              </div>
            </li>
          </ul>
        </Col>
      </Col>

      {/* Logout Confirmation Modal */}
      <Modal show={showLogout} onHide={() => setShowLogout(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Logout</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to log out?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowLogout(false)}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleLogout}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
